;(function ($) {
  "use strict"
  $(function () {
    function setHeightPlan() {
      for (let i = 1; i < 15; i++) {
        $(".js-equalize-" + i).css("height", "auto")
        let maxHeightPlan = Math.max.apply(
          null,
          $(".js-equalize-" + i)
            .map(function () {
              return $(this).outerHeight()
            })
            .get()
        )
        $(".js-equalize-" + i).outerHeight(maxHeightPlan)
      }
    }
    $(document).on("open.zf.reveal", "[data-reveal]", function () {
      setTimeout(function () {
        setHeightPlan()
      }, 100)
    })
    $(window).on("load", function () {
      setHeightPlan()
    })
    setHeightPlan()
    $(window).on("resize", function () {
      setHeightPlan()
    })
  })
})(jQuery)
